// Match changes to the workspace that owns the definition, including removals.
const FAMILY_PAGES = {
  view: ['views'],
  automation: ['automations'],
  ontology_schema_delta: ['ontology-builder'],
  operational_process_version: ['build'],
  integration_definition: ['integrations'],
  code_execution_program: ['program-editor'],
  initiative_template: ['initiatives'],
  agent: ['org-chart'],
  action: ['ontology-builder'],
  data_retrieval_contract: ['ontology-builder'],
};

const normalize = (value) =>
  String(value || '')
    .trim()
    .toLowerCase();

export const buildBranchChangeMarkers = (changes) => {
  const pages = new Set();
  const viewIds = new Set();
  const viewNames = new Set();
  for (const artifact of changes?.artifacts || []) {
    if (['unchanged', 'noop'].includes(artifact.operation)) continue;
    for (const page of FAMILY_PAGES[artifact.family] || ['build']) pages.add(page);
    if (artifact.family === 'view') {
      for (const id of [
        artifact.artifact_ref,
        artifact.base_artifact_ref,
        artifact.sandbox_artifact_id,
        artifact.base_artifact_id,
        artifact.published_id,
        artifact.payload?.id,
      ]) {
        if (id) viewIds.add(String(id));
      }
      if (artifact.name || artifact.payload?.name)
        viewNames.add(normalize(artifact.name || artifact.payload.name));
    }
  }
  // Declared review views (ADR-0045) are where this branch should be read.
  for (const row of changes?.review?.review_views || []) {
    if (row?.view_id) viewIds.add(String(row.view_id));
    if (row?.name) viewNames.add(normalize(row.name));
  }
  const data = changes?.data;
  if (
    [
      'object_upsert_count',
      'object_delete_count',
      'relationship_upsert_count',
      'relationship_delete_count',
    ].some((key) => Number(data?.[key]) > 0)
  ) {
    pages.add('ontology-data');
  }
  return {
    hasPageChanges: (page) => pages.has(page === 'view-editor' ? 'views' : page),
    hasViewChanges: (view) =>
      Boolean(
        view &&
        (viewIds.has(String(view.id)) ||
          viewIds.has(String(view.__sandbox_artifact_id)) ||
          viewIds.has(String(view.source_artifact_id)) ||
          viewIds.has(String(view.__sandbox_source_artifact_id)) ||
          viewNames.has(normalize(view.name))),
      ),
  };
};
